// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__86_7K","container__h2":"styles_container__h2__HDPco","container__swiper":"styles_container__swiper__Cae9H"};